import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Tools } from "@comunicare/comunicare-helper";
import { IPatientUser, IRelatedPerson } from "@comunicare/comunicare-interfaces";
import moment from "moment";
import { Subject } from "rxjs";
import { first, map, takeUntil } from "rxjs/operators";
import { Base64Helper } from "src/app/helpers/Base64Helper";
import { PatientService } from "src/app/providers/patient.service";
import { PatientRegistrationService } from "src/app/providers/patientRegistration.service";
import { RelatedService } from "src/app/providers/related.service";

@Component({
  selector: "app-patient-edition-page",
  templateUrl: "./patient-edition-page.component.html",
  styleUrls: ["./patient-edition-page.component.scss"],
})
export class PatientEditionPageComponent implements OnInit, OnDestroy {
  /** Subject that emits when the component has been destroyed. */
  private onDestroy$ = new Subject<void>();

  public isLoading = true;
  public patient: IPatientUser;
  public source: string;
  public relateds: IRelatedPerson[] = [];
  public addRelatedToExistingPatient = false;
  public isPatientUnder18: boolean;

  constructor(
    private router: Router,
    private relatedService: RelatedService,
    public patientRegistrationService: PatientRegistrationService,
    private patientService: PatientService,
    private cdr: ChangeDetectorRef
  ) {
    // get the previous url to redirect back the user there
    this.router.events
      .pipe(
        first(),
        map(() => this.router.getCurrentNavigation().previousNavigation?.finalUrl?.toString())
      )
      .subscribe((previousUrl) => {
        this.patientRegistrationService.previousUrl = previousUrl;
      });
  }

  ngOnInit(): void {
    const currentPath = window.location.pathname;
    const urlSegments = currentPath.split("/");
    let caremateId: string;
    if (urlSegments[1] === "patientEdition" && Tools.isDefined(urlSegments[2])) {
      caremateId = Base64Helper.b64_to_utf8(urlSegments[2]);
      if (caremateId) {
        this.patientService
          .getPatientUser(caremateId)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((patientUser) => {
            this.patient = patientUser;
            this.isPatientUnder18 = moment(this.patient.user.birthdate).isAfter(moment().subtract(18, "y"));

            this.isLoading = false;
          });
        this.relatedService
          .getPatientRelateds(caremateId)
          .pipe(first())
          .subscribe((relateds) => {
            if (relateds?.length) {
              this.relateds = relateds;
            }
          });
      }
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  public referentAddedToPatient(related: IRelatedPerson): void {
    this.addRelatedToExistingPatient = false;
    this.relateds.push(related);
  }

  public addRelated(): void {
    this.addRelatedToExistingPatient = !this.addRelatedToExistingPatient;
    this.cdr.detectChanges();
  }
}
